import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import member from './modules/member';
import order from './modules/order';

Vue.use(Vuex);

// 防止外部code影響內部
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    fetchInitialData({ dispatch }) {
      dispatch('user/fetchUser');
    }
  },
  modules: {
    user,
    member,
    order
  },
  strict: debug
});
